import React, { useCallback, useRef, useState } from 'react';

import { Minus, Plus } from '@periodica/ui-kit/icons';
import cn from 'classnames';

import * as styles from './styles.module.css';

type StepperProps = {
  onChange: (value: number) => void;
  value: number;
  ariaLabelGood?: string;
};

const minValue = 1;
const maxValue = 1000;

export function Stepper({ value, onChange, ariaLabelGood = 'предметов в заказе' }: StepperProps) {
  const [input, update] = useState(() => value);
  const inputRef = useRef<HTMLInputElement>(null);

  const syncInputWithValue = useCallback(
    (newValue: number) => {
      const updatedValue = Math.min(
        Math.max(!Number.isNaN(newValue) ? newValue : minValue, minValue),
        maxValue
      );
      onChange(updatedValue);
      update(updatedValue);
    },
    [onChange]
  );

  return (
    <div className={styles.stepper}>
      <input
        type="number"
        inputMode="numeric"
        ref={inputRef}
        value={input}
        className={styles.stepperInput}
        onBlur={() => syncInputWithValue(input)}
        onChange={(e) => update(Number.parseInt(e.target.value, 10))}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            syncInputWithValue(input);
          }
        }}
        min={minValue}
        max={maxValue}
      />
      <button
        type="button"
        tabIndex={-1} // кнопкам не нужен фокус, потому что работают горячие клавиши ⬆️ ⬇️ в инпуте
        aria-label={`Уменьшить количество ${ariaLabelGood} на 1`}
        className={cn(styles.stepperButton, styles.left, value === minValue && styles.disabled)}
        onClick={() => {
          syncInputWithValue(value - 1);
          inputRef.current?.focus();
        }}
      >
        <Minus size={20} />
      </button>
      <button
        type="button"
        tabIndex={-1}
        aria-label={`Увеличить количество ${ariaLabelGood} на 1`}
        className={cn(styles.stepperButton, styles.right, value === maxValue && styles.disabled)}
        onClick={() => {
          syncInputWithValue(value + 1);
          inputRef.current?.focus();
        }}
      >
        <Plus size={20} />
      </button>
    </div>
  );
}
